export const PieSVG = () => {
	return (
		<svg viewBox='0 0 400 400' className='w-6 h-6'>
			<g transform='translate(200 200)'>
				<g>
					<path
						className='fill-current'
						d='M10.435956924932125,-191.1128344519594A8,8,0,0,1,19.204121796804298,-199.07586922079105A200,200,0,0,1,127.18853234737497,-154.34726184588035A8,8,0,0,1,127.75784530297237,-142.51651712255278L38.903033801915626,-53.661705621496026A8,8,0,0,1,29.334864310961684,-52.33990576851919A60,60,0,0,0,16.267020816116563,-57.75278377505305A8,8,0,0,1,10.435956924932103,-65.45315494506013Z'
						color='rgb(254, 50, 78)'
					></path>
					<text
						className='text-xl font-bold'
						transform='translate(49.74884620746168,-120.10433922646727)'
						textAnchor='middle'
						alignmentBaseline='middle'
						y='-12'
					></text>
					<text
						className='text-xl font-medium'
						transform='translate(49.74884620746168,-120.10433922646727)'
						textAnchor='middle'
						alignmentBaseline='middle'
						y='12'
					></text>
				</g>
				<g>
					<path
						className='fill-current'
						d='M142.51651712255278,-127.75784530297237A8,8,0,0,1,154.34726184588035,-127.18853234737499A200,200,0,0,1,199.07586922079105,-19.204121796804277A8,8,0,0,1,191.1128344519594,-10.435956924932103L65.45315494506012,-10.435956924932103A8,8,0,0,1,57.75278377505305,-16.26702081611656A60,60,0,0,0,52.33990576851917,-29.334864310961684A8,8,0,0,1,53.66170562149601,-38.903033801915626Z'
						color='rgb(213, 3, 167)'
					></path>
					<text
						className='text-xl font-bold'
						transform='translate(120.10433922646727,-49.748846207461675)'
						textAnchor='middle'
						alignmentBaseline='middle'
						y='-12'
					></text>
					<text
						className='text-xl font-medium'
						transform='translate(120.10433922646727,-49.748846207461675)'
						textAnchor='middle'
						alignmentBaseline='middle'
						y='12'
					></text>
				</g>
				<g>
					<path
						className='fill-current'
						d='M191.1128344519594,10.435956924932103A8,8,0,0,1,199.07586922079105,19.204121796804273A200,200,0,0,1,154.34726184588035,127.18853234737497A8,8,0,0,1,142.51651712255278,127.75784530297237L53.66170562149602,38.903033801915626A8,8,0,0,1,52.33990576851917,29.334864310961684A60,60,0,0,0,57.75278377505305,16.267020816116563A8,8,0,0,1,65.45315494506012,10.435956924932103Z'
						color='rgb(130, 16, 237)'
					></path>
					<text
						className='text-xl font-bold'
						transform='translate(120.10433922646727,49.748846207461675)'
						textAnchor='middle'
						alignmentBaseline='middle'
						y='-12'
					></text>
					<text
						className='text-xl font-medium'
						transform='translate(120.10433922646727,49.748846207461675)'
						textAnchor='middle'
						alignmentBaseline='middle'
						y='12'
					></text>
				</g>
				<g>
					<path
						className='fill-current'
						d='M127.75784530297237,142.51651712255278A8,8,0,0,1,127.18853234737499,154.34726184588035A200,200,0,0,1,19.204121796804298,199.07586922079105A8,8,0,0,1,10.435956924932125,191.1128344519594L10.435956924932103,65.45315494506013A8,8,0,0,1,16.26702081611656,57.75278377505306A60,60,0,0,0,29.334864310961684,52.33990576851917A8,8,0,0,1,38.903033801915626,53.661705621496026Z'
						color='rgb(45, 84, 253)'
					></path>
					<text
						className='text-xl font-bold'
						transform='translate(49.74884620746168,120.10433922646727)'
						textAnchor='middle'
						alignmentBaseline='middle'
						y='-12'
					></text>
					<text
						className='text-xl font-medium'
						transform='translate(49.74884620746168,120.10433922646727)'
						textAnchor='middle'
						alignmentBaseline='middle'
						y='12'
					></text>
				</g>
				<g>
					<path
						className='fill-current'
						d='M-10.4359569249321,191.1128344519594A8,8,0,0,1,-19.20412179680427,199.07586922079105A200,200,0,0,1,-127.18853234737499,154.34726184588035A8,8,0,0,1,-127.75784530297238,142.51651712255276L-38.90303380191561,53.66170562149602A8,8,0,0,1,-29.334864310961674,52.33990576851918A60,60,0,0,0,-16.267020816116556,57.75278377505305A8,8,0,0,1,-10.435956924932096,65.45315494506013Z'
						color='rgb(2, 173, 208)'
					></path>
					<text
						className='text-xl font-bold'
						transform='translate(-49.74884620746167,120.10433922646727)'
						textAnchor='middle'
						alignmentBaseline='middle'
						y='-12'
					></text>
					<text
						className='text-xl font-medium'
						transform='translate(-49.74884620746167,120.10433922646727)'
						textAnchor='middle'
						alignmentBaseline='middle'
						y='12'
					></text>
				</g>
				<g>
					<path
						className='fill-current'
						d='M-142.51651712255276,127.7578453029724A8,8,0,0,1,-154.34726184588033,127.18853234737502A200,200,0,0,1,-199.07586922079105,19.204121796804262A8,8,0,0,1,-191.1128344519594,10.435956924932096L-65.45315494506012,10.435956924932121A8,8,0,0,1,-57.75278377505305,16.267020816116577A60,60,0,0,0,-52.33990576851919,29.334864310961663A8,8,0,0,1,-53.661705621496026,38.903033801915605Z'
						color='rgb(19, 240, 123)'
					></path>
					<text
						className='text-xl font-bold'
						transform='translate(-120.10433922646725,49.74884620746174)'
						textAnchor='middle'
						alignmentBaseline='middle'
						y='-12'
					></text>
					<text
						className='text-xl font-medium'
						transform='translate(-120.10433922646725,49.74884620746174)'
						textAnchor='middle'
						alignmentBaseline='middle'
						y='12'
					></text>
				</g>
				<g>
					<path
						className='fill-current'
						d='M-191.1128344519594,-10.43595692493205A8,8,0,0,1,-199.07586922079105,-19.20412179680422A200,200,0,0,1,-154.34726184588033,-127.18853234737502A8,8,0,0,1,-142.51651712255276,-127.75784530297238L-53.661705621496026,-38.9030338019156A8,8,0,0,1,-52.33990576851919,-29.334864310961667A60,60,0,0,0,-57.75278377505305,-16.267020816116567A8,8,0,0,1,-65.45315494506013,-10.435956924932103Z'
						color='rgb(90, 252, 41)'
					></path>
					<text
						className='text-xl font-bold'
						transform='translate(-120.10433922646726,-49.74884620746171)'
						textAnchor='middle'
						alignmentBaseline='middle'
						y='-12'
					></text>
					<text
						className='text-xl font-medium'
						transform='translate(-120.10433922646726,-49.74884620746171)'
						textAnchor='middle'
						alignmentBaseline='middle'
						y='12'
					></text>
				</g>
				<g>
					<path
						className='fill-current'
						d='M-127.75784530297243,-142.51651712255273A8,8,0,0,1,-127.18853234737504,-154.3472618458803A200,200,0,0,1,-19.204121796804404,-199.07586922079105A8,8,0,0,1,-10.435956924932189,-191.1128344519594L-10.435956924932103,-65.45315494506012A8,8,0,0,1,-16.267020816116563,-57.75278377505305A60,60,0,0,0,-29.334864310961702,-52.339905768519166A8,8,0,0,1,-38.90303380191564,-53.661705621496004Z'
						color='rgb(179, 203, 1)'
					></path>
					<text
						className='text-xl font-bold'
						transform='translate(-49.748846207461746,-120.10433922646725)'
						textAnchor='middle'
						alignmentBaseline='middle'
						y='-12'
					></text>
					<text
						className='text-xl font-medium'
						transform='translate(-49.748846207461746,-120.10433922646725)'
						textAnchor='middle'
						alignmentBaseline='middle'
						y='12'
					></text>
				</g>
			</g>
		</svg>
	);
};
